import {TIPS_TYPES} from '@/consts/tipsTypes';
import {getContent} from './content';
import type {TipsContent} from './tipsContent.types';

const getTypedContent = (): TipsContent => getContent() as TipsContent;

const getTipsGuide = () => getTypedContent().tipsGuide || [];
const getPostConnectionGuide = () => getTypedContent().postConnectionGuide || [];
const getDeviceOfflineGuide = () => getTypedContent().deviceOfflineGuide || [];
const getExperienceModeGuide = () => getTypedContent().experienceModeGuide || [];
const getPhoneOffline = () => getTypedContent().phoneOfflineGuide || [];

export const getTipsGuideByType = (tipsType: string) => {
    switch (tipsType) {
        case TIPS_TYPES.TIPS:
            return getTipsGuide();
        case TIPS_TYPES.POST_CONNECTION:
            return getPostConnectionGuide();
        case TIPS_TYPES.DEVICE_OFFLINE:
            return getDeviceOfflineGuide();
        case TIPS_TYPES.EXPERIENCE_MODE:
            return getExperienceModeGuide();
        case TIPS_TYPES.PHONE_OFFLINE:
            return getPhoneOffline();
        default:
            return [];
    }
};
